export async function createClientFoods(pendingFoods) {
  if (pendingFoods.length === 0) {
    alert('Please add at least one food reference.');
    return false;
  }

  try {
    const response = await fetch('/api/foods/batch-create', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ foods: pendingFoods }),
      options: {
        credentials: 'include' // Include cookies if needed
      },
    });

    if (!response.ok) throw new Error(await response.text());
      // {"message": "Foods created successfully.", "food_ids": food_ids}
      const result = await response.json();
      console.log(`✅ Foods created successfully: ${result.food_ids}`);
      return { success: true, created: result.profile_ids };
  } catch (err) {
      console.error('Failed to save food references:', err);
      return { success: false, error: err?.message || 'Unknown error' };
  }
}

export async function loadClientFoods() {
  try {
    const response = await fetch('/api/foods');
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const foods = await response.json();
    return foods;
  } catch (err) {
    console.error('[loadClientFoods] Failed:', err);
    return [];
  }
}

export async function updateClientFoods(pendingFoods) {
  try {
    const response = await fetch('/api/foods/batch-update', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      options: {
        credentials: 'include' // Include cookies if needed
      },
      body: JSON.stringify({ foods: pendingFoods })
    });

    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const result = await response.json();
    console.log(`✅ updateFoods result: ${result.message}, food_ids: ${result.food_ids}`);
    return { success: true, updated: result.food_ids };
  } catch (err) {
    console.error('Submission error:', err);
    return { success: false, error: err?.message || 'Unknown error' };
  }
}

export async function getPredefinedFoods() {
  try {
    const response = await fetch('/api/foods/predefined');
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const foods = await response.json();
    return foods["predefined_foods"]["foods"];
  } catch (err) {
    console.error('[getPredefinedFoods] Failed:', err);
    return [];
  }
}
